import { gameConfig } from '../configs';

export const calculateDegree = (num) => {
  if (num === 0) {
    return 0;
  }
  return (gameConfig.wheel.crystalCount - num) * gameConfig.wheel.stepDegree;
};
